import { color } from "../stylesGlobal";

export const light = {
    colors: {
        cinza: "#DFDFDF",
        red: "#E83939",

        background: "#FFFFFF",
        backgroundSecondary: "#F5F7FD",

        textTitle: "#444444",
        textBody: "#7F7F7F",

        categoryContainer: color.main,
        categoryBoxIcon: color.white,
        categoryIcon: color.main,

        cardVerticalBackground: color.white,
        
        cardHorizontalBackground: "#FCFCFC",
        cardHorizontalBackgroundSecondary: "#F5F5F5",

        inputsBackground: "#F5F7FD",
        inputsPlaceholder: color.gray,
        inputsText: color.grayDark,

        buttonGreen: color.green,
        buttonRed: "#E83939",
    }
}